const HealthCheck = () => (
    <div>GOOD</div>
)

export default HealthCheck;
